<template>
  <div class="content">
    <div class="form">
      <div class="form-group">
        <label>Nhập họ và tên</label>
        <input v-model="name" class="form-control" placeholder="Nhập tên của bạn"/>
      </div>

      <div class="form-group">
        <label>Ngày sinh (Định dạng ngày/tháng/năm)</label>
        <input v-model="birthday" class="form-control" placeholder="Nhập tên của bạn"/>
      </div>

      <div class="form-group gio-sinh">
        <label>Giờ sinh</label>
        <select v-model="hour">
          <option
            v-for="(value, index) in CHI"
            :key="index"
            :value="index + 1"
          >
            {{ value }} ({{ (index * 2 + 1 + 22) % 24}}h - {{ (index * 2 + 2 + 23) % 24}}h)
          </option>
        </select>
      </div>

      <div class="form-group gio-sinh">
        <label>Năm xem</label>
        <input v-model="curYear" style="width: 67%" placeholder="Nhập năm xem"/>
      </div>

      <div class="form-group" style="text-align: center;">
        <p>
          <input type="radio" id="test1" value="1" v-model="gender">
          <label for="test1">Nam</label>
        </p>
        <p>
          <input type="radio" id="test2" value="-1" v-model="gender">
          <label for="test2">Nữ</label>
        </p>
      </div>
      <button class="btn" @click="onSubmit">Gửi</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { CHI } from '../../utils/calender'
export default {
  name: 'FormInput',
  data () {
    return {
      CHI,
      name: 'Quang Thắng',
      birthday: '05/02/1996', // '7/2/1983', //
      hour: 1, // 8, //
      curYear: moment().format('YYYY'),
      gender: 1,
      type: 1
    }
  },
  methods: {
    onSubmit () {
      const data = {
        name: this.name,
        birthday: this.birthday,
        hour: this.hour,
        curYear: this.curYear,
        gender: this.gender,
        type: this.type
      }
      this.$emit('input', data)
    }
  }
}
</script>
